import React, { useState } from 'react'
import {
  StyledTable,
  FilterSection,
  FilterGroup,
  CheckboxContainer,
} from './GroupCollegeTable'
import GroupTableSearchFilter from 'components/UIComponents/GroupTableSearchFilter'
import { Tooltip } from 'antd'
import Pagination from 'components/Pagination'
import AddIcon from 'components/Images/Add_To_Queue.svg'
import ChartIcon from 'components/Images/Chat_Circle_Close.svg'
import PocAvail from 'components/Images/Poc_Avail.svg'
import EditIcon from 'components/Images/Edit_Pencil_Line_02.svg'
import TreeFilter from 'components/TreeSelectFilter'
import { Checkbox } from 'antd'
import Button from 'components/Button'
import ColoredTooltip from 'components/UIComponents/ColoredTooltip'
import TierDrawer from 'components/UIComponents/TierDrawer'
import AntdAvatar from 'components/Avatar'

const College = ({
  collegeData,
  loading,
  pageNum,
  pageLimit,
  totalCollegeCount,
  setGroupCreationDrawerVisible,
  groupCreationDrawerVisible,
  handleEditTier,
  handleEditPOC,
  pocList,
  handleAddPOC,
  handleAddToGroup,
  selectedColleges,
  onCollegeSelectChange,
  onPageChange,
  selectedCollegeIds,
  publishedIds = [],
  onSingleRowSelect,
  onSelectAllRows,
  onViewSelectedColleges,
  collegeFilters = {
    selectedTiers: [],
    selectedStates: [],
    selectedCities: [],
  },
  handleCollegeFilterChange,
  activeTab,
  filterData = { states: [], cities: [] },
  collegeSearch = '',
  setCollegeSearch = () => {},
  // Add new props for dropdown search/refresh
  stateOptions = [],
  cityOptions = [],
  onStateSearch,
  onCitySearch,
  onStateDropdownClose,
  onCityDropdownClose,
  handleSort,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const rowSelection = {}
  // Colleges this role is already published to: shown checked + locked.
  const publishedIdSet = new Set(publishedIds)

  const totalPage = 1
  const onCancelFilter = () => {}

  // Add local state and handlers for Tier search
  const defaultTierData = [
    { id: '1', name: 'Tier 1', value: 1 },
    { id: '2', name: 'Tier 2', value: 2 },
    { id: '3', name: 'Tier 3', value: 3 },
    { id: '4', name: 'Tier 4', value: 4 },
  ]
  const [tierOptions, setTierOptions] = useState(defaultTierData)

  const handleTierSearch = searchText => {
    if (!searchText) {
      setTierOptions(defaultTierData)
    } else {
      setTierOptions(
        defaultTierData.filter(tier =>
          tier.name.toLowerCase().includes(searchText.toLowerCase())
        )
      )
    }
  }
  const handleTierDropdownClose = () => {
    setTierOptions(defaultTierData)
  }

  const columns = [
    {
      title: 'College Name',
      dataIndex: 'collegeName',
      key: 'collegeName',
      render: (text, record) => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
            <>
              <AntdAvatar
                src={record.logo}
                size={36}
                IconName={
                  text && text.length > 0 ? text.trim()[0].toUpperCase() : '-'
                }
              />
              <span
                style={{
                  fontSize: 14,
                  lineHeight: '28px',
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  fontWeight: 500,
                  marginLeft: 4,
                }}
              >
                {text || '-'}
              </span>
              {publishedIdSet.has(record.instituteCampusId) && (
                <span
                  style={{
                    marginLeft: 8,
                    background: '#E0FFE5',
                    color: '#2F8F57',
                    border: '1px solid #58B981',
                    borderRadius: '20px',
                    padding: '2px 10px',
                    fontWeight: 600,
                    fontSize: 10,
                    fontFamily: 'Plus Jakarta Sans, sans-serif',
                    whiteSpace: 'nowrap',
                  }}
                >
                  Already published
                </span>
              )}
            </>
          </span>
          {record.pilRecommended && (
            <span
              style={{ marginLeft: 8, display: 'flex', alignItems: 'center' }}
            >
              <div
                style={{
                  background: '#3249D7',
                  color: '#fff',
                  borderRadius: '20px',
                  padding: '2px 14px',
                  fontWeight: 700,
                  fontSize: 10,
                  fontFamily: 'Plus Jakarta Sans, sans-serif',
                  letterSpacing: 0.2,
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxSizing: 'border-box',
                  width: 'fit-content',
                  height: 'fit-content',
                  minWidth: 40,
                  maxWidth: 120,
                  whiteSpace: 'nowrap',
                }}
              >
                PIL Recc.
              </div>
            </span>
          )}
        </div>
      ),
    },
    {
      title: 'Location',
      dataIndex: 'location',
      key: 'location',
      render: (text, record) => {
        const city = record?.city || '-'
        const state = record?.state || '-'
        return `${city}, ${state}`
      },
    },
    {
      title: 'Tier',
      dataIndex: 'tier',
      key: 'tier',
      align: 'center',
      sorter: (a, b) => {
        const tierA = a?.corporateDetails?.tier || a?.tier || 0
        const tierB = b?.corporateDetails?.tier || b?.tier || 0
        return tierA - tierB
      },
      render: (text, record) => {
        let tier = record?.corporateDetails?.tier
          ? record?.corporateDetails?.tier
          : record?.tier

        let backgroundColor = '#eee'
        let color
        let border

        switch (tier) {
          case 1:
            backgroundColor = '#FFE5ED'
            color = '#964D65'
            border = '1px solid #964D65'
            break
          case 2:
            backgroundColor = '#E7E0FF'
            color = '#7D64DA'
            border = '1px solid #7D64DA'
            break
          case 3:
            backgroundColor = '#E0F7FF'
            color = '#55A1BA'
            border = '1px solid #55A1BA'
            break
          case 4:
            backgroundColor = '#E0FFE5'
            color = '#58B981'
            border = '1px solid #58B981'
            break
          default:
            backgroundColor = '#e0e0e0'
        }

        return (
          <div
            style={{ display: 'flex', justifyContent: 'center', gap: '10px' }}
          >
            <div
              style={{
                backgroundColor,
                color,
                border,
                borderRadius: '15px',
                padding: '4px 12px',
                minWidth: '80px',
                fontWeight: 500,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              Tier {tier || '-'}
            </div>
            <Tooltip title="Edit">
              <div
                style={{ cursor: 'pointer' }}
                onClick={() => handleEditTier(record)}
              >
                <img
                  src={EditIcon}
                  alt="Edit"
                  style={{ width: 30, height: 30 }}
                />
              </div>
            </Tooltip>
          </div>
        )
      },
    },
    {
      title: 'Action Items',
      key: 'actions',
      align: 'center',
      render: (text, record) => (
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          {!record?.pocDetails?.length ? (
            <ColoredTooltip title="POC" coloredTitle="NA" color="#E35E50">
              <div
                style={{ fontSize: '16px', cursor: 'pointer' }}
                onClick={() => handleEditPOC(record)}
              >
                <img
                  src={ChartIcon}
                  alt="Delete"
                  style={{ width: 35, height: 35, cursor: 'pointer' }}
                  onClick={() => handleEditPOC(record)}
                />
              </div>
            </ColoredTooltip>
          ) : (
            <ColoredTooltip title="POC" coloredTitle="Avail." color="#58B981">
              <div
                style={{ fontSize: '16px', cursor: 'pointer' }}
                onClick={() => handleEditPOC(record)}
              >
                <img
                  src={PocAvail}
                  alt="Delete"
                  style={{ width: 29, height: 29, cursor: 'pointer' }}
                  onClick={() => handleEditPOC(record)}
                />
              </div>
            </ColoredTooltip>
          )}
          <Tooltip title="Add to group">
            <div
              style={{
                fontSize: '16px',
                cursor: selectedColleges.length > 0 ? 'not-allowed' : 'pointer',
                opacity: selectedColleges.length > 0 ? 0.5 : 1,
              }}
              onClick={() => {
                if (selectedColleges.length === 0) {
                  handleAddToGroup(record)
                }
              }}
            >
              <img
                src={AddIcon}
                alt="Add"
                style={{
                  width: 30,
                  height: 30,
                  cursor:
                    selectedColleges.length > 0 ? 'not-allowed' : 'pointer',
                  opacity: selectedColleges.length > 0 ? 0.5 : 1,
                }}
                onClick={e => {
                  e.stopPropagation()
                  if (selectedColleges.length === 0) {
                    handleAddToGroup(record)
                  }
                }}
              />
            </div>
          </Tooltip>
        </div>
      ),
    },
  ]

  const selectionConfig = {
    // Show user-selected colleges AND already-published ones as checked.
    selectedRowKeys: Array.from(
      new Set([...(selectedCollegeIds || []), ...publishedIds])
    ),
    onSelect: onSingleRowSelect,
    onSelectAll: onSelectAllRows,
    // Lock already-published rows so they cannot be unchecked or re-selected.
    getCheckboxProps: record => ({
      disabled: publishedIdSet.has(record.instituteCampusId),
    }),
  }

  return (
    <>
      <FilterSection>
        <CheckboxContainer>
          <Checkbox
            checked={collegeFilters.pilRecommended}
            onChange={e =>
              handleCollegeFilterChange(e.target.checked, 'pilRecommended')
            }
            style={{ color: '#000000', fontWeight: 500 }}
          >
            Show only PIL Recc.
          </Checkbox>
        </CheckboxContainer>

        <FilterGroup>
          <TreeFilter
            label="State"
            placeholder="Select filter"
            treeData={stateOptions.map(state => ({
              id: state.stateId,
              name: state.state,
              value: state.stateId,
            }))}
            value={collegeFilters.selectedStates}
            onChange={handleCollegeFilterChange}
            onSearch={onStateSearch}
            onDropdownClose={onStateDropdownClose}
            valueKey="selectedStates"
            labelColor="#000000"
          />
        </FilterGroup>
        <FilterGroup>
          <TreeFilter
            label="City"
            placeholder="Select filter"
            treeData={cityOptions.map(city => ({
              id: city.cityId,
              name: city.city,
              value: city.cityId,
            }))}
            value={collegeFilters.selectedCities}
            onChange={handleCollegeFilterChange}
            onSearch={onCitySearch}
            onDropdownClose={onCityDropdownClose}
            valueKey="selectedCities"
            labelColor="#000000"
          />
        </FilterGroup>
        <FilterGroup>
          <TreeFilter
            label="Tier Levels"
            placeholder="Select filter"
            treeData={tierOptions}
            value={collegeFilters.selectedTiers}
            onChange={handleCollegeFilterChange}
            onSearch={handleTierSearch}
            onDropdownClose={handleTierDropdownClose}
            valueKey="selectedTiers"
            labelColor="#000000"
          />
        </FilterGroup>
      </FilterSection>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          margin: '20px 0',
        }}
      >
        <Button
          style={{
            height: 30,
            padding: '0 20px',
            borderRadius: 15,
            backgroundColor:
              selectedColleges.length > 0 ? '#3249D7' : '#e0e0e0',
            color: '#ffffff',
            fontSize: 16,
            fontWeight: 500,
            border: 'none',
            cursor: selectedColleges.length > 0 ? 'pointer' : 'not-allowed',
          }}
          disabled={selectedColleges.length === 0}
          onClick={() => onViewSelectedColleges(false)}
        >
          View Selected colleges
        </Button>
      </div>
      <GroupTableSearchFilter
        menu={{}}
        open={isMenuOpen}
        setOpen={setIsMenuOpen}
        searchValue={collegeSearch}
        setSearchValue={setCollegeSearch}
        totalCount={totalCollegeCount}
        currentCount={Math.min(pageNum * pageLimit, totalCollegeCount)}
        onOpenChange={handleAddToGroup}
        onCancelFilter={onCancelFilter}
        name="Group"
        iconName={AddIcon}
        padding="false"
        onAddToGroup={handleAddToGroup}
        activeTab={activeTab}
        selectedColleges={selectedColleges}
      />
      <StyledTable
        rowSelection={selectionConfig}
        rowKey="instituteCampusId"
        columns={columns}
        dataSource={collegeData || []}
        loading={loading}
        onChange={(pagination, filters, sorter) =>
          handleSort(pagination, filters, sorter, 'college')
        }
        pagination={false}
      />

      {totalCollegeCount > 0 && (
        <Pagination
          onChange={(page, pageSize) => onPageChange('college', page, pageSize)}
          totalPages={totalCollegeCount}
          pageSize={pageLimit}
          current={pageNum}
        />
      )}
    </>
  )
}

export default College
